import { getCakeAddress, getCornAddress, getTmtAddress, getCoinAddress } from 'utils/addressHelpers'
import { PoolCategory, PoolConfig, QuoteToken } from './types'

const pools: PoolConfig[] = [
  {
    sousId: 21,
    tokenName: QuoteToken.AUSDT,
    stakingTokenName: QuoteToken.CN,
    stakingTokenAddress: `${getCoinAddress()}`,
    contractAddress: {
      43114: '0x53eeC9954872A9b4d82dCb0521fB37B0FFEd5bD4',
    },
    poolCategory: PoolCategory.PREFARM,
    projectLink: 'https://farmersonly.farm/',
    harvest: true,
    tokenPerBlock: '0.00010582',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
  {
    sousId: 1,
    tokenName: QuoteToken.CAKE,
    stakingTokenName: QuoteToken.CORN,
    stakingTokenAddress: `${getCornAddress()}`,
    contractAddress: {
      43114: '0x14fE3937Aea5A08A7e002662F0Afe40Dd2fA1f15',
    },
    poolCategory: PoolCategory.PREFARM,
    projectLink: 'https://farmersonly.farm/',
    harvest: true,
    tokenPerBlock: '0.00010582',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
  {
    sousId: 2,
    tokenName: QuoteToken.CAKE,
    stakingTokenName: QuoteToken.TMT,
    stakingTokenAddress: `${getTmtAddress()}`,
    contractAddress: {
      43114: '0x53E017F26f0b3b5e1dF092276a6F42792cFA16f7',
    },
    poolCategory: PoolCategory.PREFARM,
    projectLink: 'https://farmersonly.farm/',
    harvest: true,
    tokenPerBlock: '0.00005291',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
  {
    sousId: 3,
    tokenName: 'USDT.e',
    stakingTokenName: QuoteToken.CAKE,
    stakingTokenAddress: `${getCakeAddress()}`,
    contractAddress: {
      43114: '0xfCB6b8791777984581E40FE915FDDfeC4cb5e596',
    },
    poolCategory: PoolCategory.CORE,
    projectLink: 'https://farmersonly.farm/',
    harvest: true,
    tokenPerBlock: '0.004629',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 6,
  },
  {
    sousId: 4,
    tokenName: 'denverFOS',
    stakingTokenName: QuoteToken.CAKE,
    stakingTokenAddress: `${getCakeAddress()}`,
    contractAddress: {
      43114: '0x14D3218b65E170C5B3e8FD96F569785Eaabad0D5',
    },
    poolCategory: PoolCategory.CORE,
    projectLink: 'https://farmersonly.farm/',
    harvest: true,
    tokenPerBlock: '0.00033',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
  {
    sousId: 5,
    tokenName: 'WAVAX',
    stakingTokenName: QuoteToken.CAKE,
    stakingTokenAddress: `${getCakeAddress()}`,
    contractAddress: {
      43114: '0x0514fDaE7C024E658A9BE9E64B38BCb9485F928e',
    },
    poolCategory: PoolCategory.CORE,
    projectLink: 'https://farmersonly.farm/',
    harvest: true,
    tokenPerBlock: '0.0000165',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
  {
    sousId: 6,
    tokenName: 'USDT.e',
    stakingTokenName: QuoteToken.CAKE,
    stakingTokenAddress: `${getCakeAddress()}`,
    contractAddress: {
      43114: '0x849CF1E4209cC7F6cF196c35F28F831EfEdF796e',
    },
    poolCategory: PoolCategory.FIRE,
    projectLink: 'https://farmersonly.farm/',
    harvest: true,
    tokenPerBlock: '0.277777',
    sortOrder: 1,
    isFinished: true,
    tokenDecimals: 7,
  },
  {
    sousId: 7,
    tokenName: 'WBTC.e',
    stakingTokenName: QuoteToken.CAKE,
    stakingTokenAddress: `${getCakeAddress()}`,
    contractAddress: {
      43114: '0x03d7365B6476639278192418e4128a3D03309Cc5',
    },
    poolCategory: PoolCategory.CORE,
    projectLink: 'https://farmersonly.farm/',
    harvest: true,
    tokenPerBlock: '0.00000081',
    sortOrder: 1,
    isFinished: true,
    tokenDecimals: 26,
  },
  {
    sousId: 8,
    tokenName: QuoteToken.CAKE,
    stakingTokenName: QuoteToken.CORN,
    stakingTokenAddress: `${getCornAddress()}`,
    contractAddress: {
      43114: '0x057476Fa5d79072BBd172f3F4a45e6D5d8CfBdD7',
    },
    poolCategory: PoolCategory.FIRE,
    projectLink: 'https://farmersonly.farm/',
    harvest: true,
    tokenPerBlock: '0.00010417',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
  {
    sousId: 9,
    tokenName: QuoteToken.CAKE,
    stakingTokenName: QuoteToken.TMT,
    stakingTokenAddress: `${getTmtAddress()}`,
    contractAddress: {
      43114: '0x90382b21ab324df129C867766b9036224a70a8c9',
    },
    poolCategory: PoolCategory.FIRE,
    projectLink: 'https://farmersonly.farm/',
    harvest: true,
    tokenPerBlock: '0.00010417',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
  {
    sousId: 10,
    tokenName: 'USDT.e',
    stakingTokenName: QuoteToken.CORN,
    stakingTokenAddress: `${getCornAddress()}`,
    contractAddress: {
      43114: '0x00e5373b3697feA5DF4D5b5Bf8f68E376a661B0B',
    },
    poolCategory: PoolCategory.FIRE,
    projectLink: 'https://farmersonly.farm/',
    harvest: true,
    tokenPerBlock: '0.139',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 6,
  },
  {
    sousId: 11,
    tokenName: 'USDT.e',
    stakingTokenName: QuoteToken.TMT,
    stakingTokenAddress: `${getTmtAddress()}`,
    contractAddress: {
      43114: '0xd568D1D92C69E9a484E042Fb23290606BFF1A703',
    },
    poolCategory: PoolCategory.FIRE,
    projectLink: 'https://farmersonly.farm/',
    harvest: true,
    tokenPerBlock: '0.139',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 6,
  },
  {
    sousId: 20,
    tokenName: QuoteToken.TMT,
    stakingTokenName: QuoteToken.CAKE,
    stakingTokenAddress: `${getCakeAddress()}`,
    contractAddress: {
      43114: '0x11f3E6E6307fcE921228ffD67A614C2d75a2A8cC',
    },
    poolCategory: PoolCategory.CORE,
    projectLink: 'https://farmersonly.farm/',
    harvest: true,
    tokenPerBlock: '0.00364583',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
  {
    sousId: 19,
    tokenName: QuoteToken.CAKE,
    stakingTokenName: QuoteToken.TMT,
    stakingTokenAddress: `${getTmtAddress()}`,
    contractAddress: {
      43114: '0x476FF7bf41060eBbc42B0F6B6c8658af66752C88',
    },
    poolCategory: PoolCategory.CORE,
    projectLink: 'https://farmersonly.farm/',
    harvest: true,
    tokenPerBlock: '0.00028935',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
  {
    sousId: 18,
    tokenName: QuoteToken.CAKE,
    stakingTokenName: QuoteToken.CORN,
    stakingTokenAddress: `${getCornAddress()}`,
    contractAddress: {
      43114: '0x3D04a3Ea90B223361a132266b0c2d1b779c76251',
    },
    poolCategory: PoolCategory.CORE,
    projectLink: 'https://farmersonly.farm/',
    harvest: true,
    tokenPerBlock: '0.00011574',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
  {
    sousId: 17,
    tokenName: QuoteToken.CORN,
    stakingTokenName: QuoteToken.CAKE,
    stakingTokenAddress: `${getCakeAddress()}`,
    contractAddress: {
      43114: '0x5e5C2Db2599bb0197560dE2F4C957552178c3A40',
    },
    poolCategory: PoolCategory.CORE,
    projectLink: 'https://farmersonly.farm/',
    harvest: true,
    tokenPerBlock: '0.00303819',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
  {
    sousId: 16,
    tokenName: QuoteToken.CAKE,
    stakingTokenName: QuoteToken.TMT,
    stakingTokenAddress: `${getTmtAddress()}`,
    contractAddress: {
      43114: '0xbf07042Fa8d526fa72f53f7f483a9a6BD7c641cF',
    },
    poolCategory: PoolCategory.CORE,
    projectLink: 'https://farmersonly.farm/',
    harvest: true,
    tokenPerBlock: '0.00003472',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
  {
    sousId: 15,
    tokenName: QuoteToken.CAKE,
    stakingTokenName: QuoteToken.CORN,
    stakingTokenAddress: `${getCornAddress()}`,
    contractAddress: {
      43114: '0x4B7D505c397acD4DD40Ee60576cCE0668dCb1779',
    },
    poolCategory: PoolCategory.CORE,
    projectLink: 'https://farmersonly.farm/',
    harvest: true,
    tokenPerBlock: '0.00003472',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
  {
    sousId: 14,
    showWhenStart: true,
    fixedStartTime: 1638244800,
    tokenName: 'WETH.e',
    stakingTokenName: QuoteToken.CAKE,
    stakingTokenAddress: `${getCakeAddress()}`,
    contractAddress: {
      43114: '0x7dD2910A94B911E07fe77A453bDC5517D662b203',
    },
    poolCategory: PoolCategory.CORE,
    projectLink: 'https://farmersonly.farm/',
    harvest: true,
    tokenPerBlock: '0.00001505',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
  {
    sousId: 13,
    tokenName: 'WBTC.e',
    stakingTokenName: QuoteToken.CAKE,
    stakingTokenAddress: `${getCakeAddress()}`,
    contractAddress: {
      43114: '0x765279F430Fe4243Fd8167C54fB9a1f7Dd7826b7',
    },
    poolCategory: PoolCategory.CORE,
    projectLink: 'https://farmersonly.farm/',
    harvest: true,
    tokenPerBlock: '0.00000081',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 8,
  },
  {
    sousId: 12,
    tokenName: QuoteToken.TMT,
    stakingTokenName: QuoteToken.CAKE,
    stakingTokenAddress: `${getCakeAddress()}`,
    contractAddress: {
      43114: '0x983Cd461e194AfD69FBC7EF751511945C6bf8CB9',
    },
    poolCategory: PoolCategory.FIRE,
    projectLink: 'https://farmersonly.farm/',
    harvest: true,
    tokenPerBlock: '0.00746528',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },

  {
    sousId: 101,
    tokenName: QuoteToken.CAKE,
    stakingTokenName: QuoteToken.CAKE,
    stakingTokenAddress: getCakeAddress(),
    contractAddress: {
      43114: '0x6D3541CCfdeD3B41971e607cF5CD521e816022Ac',
    },
    poolCategory: PoolCategory.KING,
    projectLink: 'https://farmersonly.farm/',
    harvest: false,
    tokenPerBlock: '0',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
  {
    sousId: 99,
    tokenName: QuoteToken.CORN,
    stakingTokenName: QuoteToken.CORN,
    stakingTokenAddress: getCornAddress(),
    contractAddress: {
      43114: '0x2796bd827B9D53b505F927eA0958be1e78553e57',
    },
    poolCategory: PoolCategory.KING,
    projectLink: 'https://farmersonly.farm/',
    harvest: false,
    tokenPerBlock: '0',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
  {
    sousId: 100,
    tokenName: QuoteToken.TMT,
    stakingTokenName: QuoteToken.TMT,
    stakingTokenAddress: getTmtAddress(),
    contractAddress: {
      43114: '0x43B45f9AD77D2767A642CF236fc1c17DaeE5bb4A',
    },
    poolCategory: PoolCategory.KING,
    projectLink: 'https://farmersonly.farm/',
    harvest: false,
    tokenPerBlock: '0',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },

  {
    sousId: 102,
    tokenName: QuoteToken.TMT,
    stakingTokenName: QuoteToken.TMT,
    stakingTokenAddress: getTmtAddress(),
    contractAddress: {
      43114: '0x23225dED81c363b7563F3941951111879863a843',
    },
    poolCategory: PoolCategory.VOTE,
    projectLink: 'https://farmersonly.farm/',
    harvest: false,
    tokenPerBlock: '0',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
  {
    sousId: 103,
    tokenName: QuoteToken.CORN,
    stakingTokenName: QuoteToken.CORN,
    stakingTokenAddress: getCornAddress(),
    contractAddress: {
      43114: '0xA91fAe8337f065Ab4312f51153130c176651460E',
    },
    poolCategory: PoolCategory.VOTE,
    projectLink: 'https://farmersonly.farm/',
    harvest: false,
    tokenPerBlock: '0',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
]

export default pools
